import { render, staticRenderFns } from "./WebStore.vue?vue&type=template&id=fd8940e4&scoped=true&"
import script from "./WebStore.vue?vue&type=script&lang=js&"
export * from "./WebStore.vue?vue&type=script&lang=js&"
import style0 from "./WebStore.vue?vue&type=style&index=0&id=fd8940e4&prod&lang=scss&"
import style1 from "./WebStore.vue?vue&type=style&index=1&id=fd8940e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8940e4",
  null
  
)

export default component.exports